import { TypeNumIdentificationNational } from "./TypeNumIdentificationNational";
import { TypeOuiNonGrpAcheteur } from "./TypeOuiNonGrpAcheteur";

export class TypeAdresseFNS {

	public ville: string;

	public typeIdentificationNational: TypeNumIdentificationNational;

	public codeIdentificationNational: string;

	public cp: string;

	public nomOfficiel: string;

	public grpCommandes: TypeOuiNonGrpAcheteur;

	constructor() {
		this.ville = '';
		this.typeIdentificationNational = new TypeNumIdentificationNational();
		this.codeIdentificationNational = '';
		this.cp = '';
		this.nomOfficiel = '';
		this.grpCommandes = new TypeOuiNonGrpAcheteur();
	}
}
